<section class="foundations">
  <h2 class="foundations__title">Foundations</h2>
  <p class="foundations__intro">
    Referencia de tokens de color (ver <code>library/colors/colors.scss</code>) y muestras de tipografía cargadas con el Design System (<code>library/labels/text-tags.scss</code>, <code>library/fonts/fonts.scss</code>).
  </p>

  <h3 class="foundations__section-title">Primarios (azul)</h3>
  <div class="foundations__swatches">
    <div *ngFor="let s of primaryBlues" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>

  <h3 class="foundations__section-title">Neutros (grey light)</h3>
  <div class="foundations__swatches">
    <div *ngFor="let s of greyLight" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>

  <h3 class="foundations__section-title">Estado: verde / amarillo / rojo</h3>
  <div class="foundations__swatches">
    <div *ngFor="let s of statusGreen" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>
  <div class="foundations__swatches">
    <div *ngFor="let s of statusYellow" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>
  <div class="foundations__swatches">
    <div *ngFor="let s of statusRed" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>

  <h3 class="foundations__section-title">MAIA</h3>
  <div class="foundations__swatches">
    <div *ngFor="let s of maia" class="foundations__swatch">
      <div class="foundations__chip" [style.background]="s.hex"></div>
      <span class="foundations__token">{{ s.token }}</span>
      <span class="foundations__hex">{{ s.hex }}</span>
    </div>
  </div>

  <h3 class="foundations__section-title">Tipografía (text-tags / clases globales)</h3>
  <div class="foundations__type-samples">
    <p class="o_400">Overline o_400 — ejemplo de texto secundario</p>
    <p class="h6_600">Heading 6 · h6_600</p>
    <p class="b1_400">Body 1 · b1_400 — párrafo estándar</p>
    <p class="c1_500">Caption 1 · c1_500</p>
    <p class="subtitle-1">Clase .subtitle-1 (15px / 500)</p>
    <p class="body-1">Clase .body-1 (15px / 400)</p>
  </div>
</section>
